import React, { useEffect, useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import { apiGet, apiPost } from '../../../lib/shopperApi';

const Preferences = () => {
  const [account, setAccount] = useState(null);
  const [newsletter, setNewsletter] = useState(false);
  const [busy, setBusy]   = useState(false);
  const [msg, setMsg]     = useState(null);
  const [err, setErr]     = useState(null);
  const [dirty, setDirty] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { ok, data } = await apiGet('/me');
      if (cancelled) return;
      if (ok && data?.account) {
        setAccount(data.account);
        setNewsletter(!!data.account.newsletter_opt_in);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const toggle = (v) => { setNewsletter(v); setDirty(true); setMsg(null); setErr(null); };

  const save = async () => {
    setBusy(true); setErr(null); setMsg(null);
    const { ok, data } = await apiPost('/update-profile', { newsletter_opt_in: newsletter });
    setBusy(false);
    if (!ok) { setErr(data?.error || 'Could not save preferences.'); return; }
    if (data?.account) setAccount(data.account);
    setMsg('Preferences saved.');
    setDirty(false);
  };

  return (
    <div className="max-w-4xl space-y-6">
      <div className="bg-white rounded-lg border border-border overflow-hidden">
        <div className="px-6 py-4 border-b border-border">
          <h2 className="text-lg font-semibold text-foreground">Newsletter & Marketing</h2>
          <p className="text-sm text-muted-foreground mt-1">Choose what we email you about.</p>
        </div>
        <div className="p-6 space-y-4">
          {msg && <p className="text-sm text-green-700">{msg}</p>}
          {err && <p className="text-sm text-red-700">{err}</p>}

          <label className="flex items-start gap-3 cursor-pointer">
            <input
              type="checkbox"
              checked={newsletter}
              onChange={(e) => toggle(e.target.checked)}
              className="w-4 h-4 mt-0.5 accent-primary rounded"
            />
            <span>
              <span className="block font-medium text-foreground">Newsletter</span>
              <span className="block text-sm text-muted-foreground">
                Get new product launches, restock alerts, and exclusive offers from Bounderlaster.
              </span>
            </span>
          </label>

          <div className="flex items-center justify-end pt-2">
            <Button onClick={save} disabled={!dirty || busy} iconName="Check" iconPosition="left">
              {busy ? 'Saving…' : 'Save Preferences'}
            </Button>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg border border-border overflow-hidden">
        <div className="px-6 py-4 border-b border-border">
          <h2 className="text-lg font-semibold text-foreground">Order Notifications</h2>
          <p className="text-sm text-muted-foreground mt-1">How you'll hear about each order.</p>
        </div>
        <div className="p-6 space-y-3 text-sm">
          <div className="flex items-start gap-3">
            <Icon name="Mail" size={18} className="text-primary mt-0.5" />
            <div>
              <p className="font-medium text-foreground">Email updates</p>
              <p className="text-muted-foreground">
                Order confirmation, shipping updates, and delivery notices are sent to{' '}
                <span className="font-medium text-foreground">{account?.email || 'your account email'}</span>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Preferences;
